module.exports = __webpack_public_path__ + "img/pressureSensor.061705b8.svg";